export function onGetValueOptionsEditDoc(currentFormikValue) {
    if (currentFormikValue?.id !== undefined) {
        return currentFormikValue?.id
    } else {
        return currentFormikValue
    }
}